import { readingValueBackgroundColorFor } from "../dashboardData"

const ThresholdLegend = () => (
  <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2">
    <div className="flex items-center gap-2">
      <span
        className="h-[17px] w-[17px] rounded-[4px] shadow-swatch"
        style={{ backgroundColor: readingValueBackgroundColorFor("critical-low") }}
      />
      <span className="whitespace-nowrap text-[14px] font-medium text-primary-contrast">
        Critical low
      </span>
    </div>
    <div className="flex items-center gap-2">
      <span
        className="h-[17px] w-[17px] rounded-[4px] shadow-swatch"
        style={{ backgroundColor: readingValueBackgroundColorFor("acceptable") }}
      />
      <span className="whitespace-nowrap text-[14px] font-medium text-primary-contrast">
        Low, acceptable or elevated
      </span>
    </div>
    <div className="flex items-center gap-2">
      <span
        className="h-[17px] w-[17px] rounded-[4px] shadow-swatch"
        style={{ backgroundColor: readingValueBackgroundColorFor("critical-high") }}
      />
      <span className="whitespace-nowrap text-[14px] font-medium text-primary-contrast">
        High
      </span>
    </div>
    <div className="flex items-center gap-2">
      <span
        className="flex h-[17px] w-[17px] items-center justify-center rounded-[4px] text-[10px] leading-none text-primary-contrast shadow-swatch"
        style={{ backgroundColor: readingValueBackgroundColorFor("acceptable") }}
      >
        -
      </span>
      <span className="whitespace-nowrap text-[14px] font-medium text-primary-contrast">
        No data
      </span>
    </div>
  </div>
)

export default ThresholdLegend
